import { render, staticRenderFns } from "./RiasecResults.vue?vue&type=template&id=c99d8f30"
import script from "./RiasecResults.vue?vue&type=script&lang=js"
export * from "./RiasecResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports